/*
 * View for the topic publish modal
 */

define(["marionette", "./template/topicEnableModalTemplate.html"], function (
  Marionette,
  TopicEnableModalTemplate,
) {
  var TopicEnableModalView = {};

  TopicEnableModalView.topicEnableModalLayout = Marionette.Layout.extend({
    template: TopicEnableModalTemplate,
    regions: {
      responseList: "#enableResponseList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#responseError").hide();
    },
    showError: function () {
      this.$el.find("#responseError").attr("data-i18n", "topic.enable.error").i18n().show();
    },
  });

  return TopicEnableModalView;
});
